/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletIcon64Regular = forwardRef('TextBulletIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M12 16.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" }),
        React.createElement("path", { d: "M23 12.5a1.5 1.5 0 0 1 1.5-1.5h30a1.5 1.5 0 0 1 0 3h-30a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M24.5 30a1.5 1.5 0 0 0 0 3h30a1.5 1.5 0 0 0 0-3h-30Z" }),
        React.createElement("path", { d: "M24.5 49a1.5 1.5 0 0 0 0 3h30a1.5 1.5 0 0 0 0-3h-30Z" }),
        React.createElement("path", { d: "M16 31.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z" }),
        React.createElement("path", { d: "M12 54.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" })));
});
